import { render, staticRenderFns } from "./WarningModal.vue?vue&type=template&id=50dc59b0&scoped=true"
import script from "./WarningModal.vue?vue&type=script&lang=ts"
export * from "./WarningModal.vue?vue&type=script&lang=ts"
import style0 from "./WarningModal.vue?vue&type=style&index=0&id=50dc59b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dc59b0",
  null
  
)

export default component.exports